import React from "react";
import { Button } from "react-bootstrap";
import "../../containers/ConfirmOpenTicket.css";
import { translations } from "../../containers/assets/translations";
import { B2B_PROXY } from "../../containers/assets/config";

export default class VoucherDisplay extends React.Component {
  openConfirmationPdf = (e, index) => {
    e.preventDefault();
    const pdfData =
      this.props.confirmationPDFArray &&
      this.props.confirmationPDFArray[index];
    if (!pdfData) return;
    if (pdfData.startsWith("http://") || pdfData.startsWith("https://") || pdfData.startsWith("blob:")) {
      window.open(pdfData, "_blank");
      return;
    }
    const byteCharacters = atob(pdfData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], {
      type: "application/pdf",
    });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  };

  render() {
    return (
      <div ref={this.props.jumpToTop}>
        {this.props.displayVouchers ? (
          <div>
            {this.props.hasPersonVouchers ? (
              <div className="col-md-12 head">
                <div className="col-md-4">
                  {translations[this.props.lang]["Ticket Number"]}
                </div>

                <div className="col-md-4">
                  {translations[this.props.lang]["Surname Name"]}
                </div>
                {!this.props.hasCancelledTickets ? (
                  <div className="col-md-4">
                    {
                      translations[this.props.lang][
                      "Download Boarding Card Pdf"
                      ]
                    }
                  </div>
                ) : (
                    <div className="col-md-4">
                      {translations[this.props.lang]["Status"]}
                    </div>
                  )}
              </div>
            ) : null}
            {this.props.boardingCardVouchers.map((voucher, index) => {
              if (!this.props.hasCancelledTickets) {
                if (!voucher.hasOwnProperty("RegistrationNumber")) {
                  return (
                    <div
                      className="col-md-12 col-xs-12 resultsRTicks"
                      key={voucher.BookID}
                    >
                      <div className="col-md-4 col-xs-4 resultVouch">
                        {voucher.TicketNumber}
                      </div>

                      <div className="col-md-4 col-xs-4 resultVouch">
                        {voucher.Surname} {voucher.GivenName}
                      </div>

                      <div className="col-md-4 col-xs-4 resultVouchbtn">
                        <a
                          href="#"
                          onClick={(e) => this.openConfirmationPdf(e, index)}
                        >
                          {translations[this.props.lang]["Download"]}
                          {"\t\t\t\t"}
                          <span className="glyphicon glyphicon-download-alt" />
                        </a>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div key={voucher.BookID}>
                      <div className="col-md-12 head HeaderVoucherVeh">
                        <div className="col-md-2">
                          {translations[this.props.lang]["Ticket Number"]}
                        </div>

                        <div className="col-md-4">
                          {translations[this.props.lang]["Driver Name"]}
                        </div>
                        <div className="col-md-2">
                          {translations[this.props.lang]["Plates"]}
                        </div>
                        <div className="col-md-4">
                          {
                            translations[this.props.lang][
                            "Download Boarding Card Pdf"
                            ]
                          }
                        </div>
                      </div>
                      <div
                        className="col-md-12 col-xs-12 resultsRTicks"
                        key={voucher.BookID}
                      >
                        <div className="col-md-2 col-xs-3 resultVouch">
                          {voucher.TicketNumber}
                        </div>

                        <div className="col-md-4 col-xs-4 resultVouch">
                          {voucher.DriverName}
                        </div>
                        <div className="col-md-2 col-xs-1 resultVouch">
                          {voucher.RegistrationNumber}
                        </div>
                        <div className="col-md-4 col-xs-4 resultVouchbtn">
                          <a
                            href="#"
                            onClick={(e) => this.openConfirmationPdf(e, index)}
                          >
                            {translations[this.props.lang]["Download"]}
                            {"\t\t\t\t"}
                            <span className="glyphicon glyphicon-download-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                }
              } else {
                if (!voucher.hasOwnProperty("RegistrationNumber")) {
                  return (
                    <div
                      className="col-md-12 col-xs-12 resultsRTicks"
                      key={voucher.BookID}
                    >
                      <div className="col-md-4 col-xs-4 resultVouch">
                        {voucher.TicketNumber}
                      </div>

                      <div className="col-md-4 col-xs-4 resultVouch">
                        {voucher.Surname} {voucher.GivenName}
                      </div>
                      <div className="col-md-4 col-xs-4 resultVouch">
                        {translations[this.props.lang]["Cancelled"]}
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div key={voucher.BookID}>
                      <div className="col-md-12 head HeaderVoucherVeh">
                        <div className="col-md-2">
                          {translations[this.props.lang]["Ticket Number"]}
                        </div>

                        <div className="col-md-4">
                          {translations[this.props.lang]["Driver Name"]}
                        </div>
                        <div className="col-md-2">
                          {translations[this.props.lang]["Plates"]}
                        </div>
                      </div>
                      <div
                        className="col-md-12 col-xs-12 resultsRTicks"
                        key={voucher.BookID}
                      >
                        <div className="col-md-2 col-xs-3 resultVouch">
                          {voucher.TicketNumber}
                        </div>

                        <div className="col-md-4 col-xs-4 resultVouch">
                          {voucher.DriverName}
                        </div>
                        <div className="col-md-2 col-xs-1 resultVouch">
                          {voucher.RegistrationNumber}
                        </div>
                        <div className="col-md-4 col-xs-4 resultVouch">
                          {translations[this.props.lang]["Cancelled"]}
                        </div>
                      </div>
                    </div>
                  );
                }
              }
            })}
            {this.props.hasCancelledTickets ? (
              <Button
                className="btn btn-primary checkin btn btn-lg "
                bsSize="large"
                type="button"
                onClick={() => this.props.goBackToFirstScreen()}
              >
                {translations[this.props.lang]["Go Back"]}
                {"\t\t\t\t"}
                <span className="glyphicon glyphicon-circle-arrow-left" />
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmOpenTicketComponents/VoucherDisplay.js